module.exports = __webpack_public_path__ + "img/logo_IMQ21.2e10b1bd.png";